import { isCurveVertex } from '@i-ark/models';

const CURVE_BOUNDBOX_CHECKS = 100;
const extractBoundingBoxFromPolygonVertices = (vertices) => {
  var _a;
  const boundingBox = {
    top: Infinity,
    bottom: -Infinity,
    left: Infinity,
    right: -Infinity,
    width: 0,
    height: 0
  };
  let prevCoord = (_a = vertices[vertices.length - 1]) == null ? void 0 : _a.coordinate;
  if (!prevCoord) {
    return boundingBox;
  }
  for (const vertex of vertices) {
    if (isCurveVertex(vertex)) {
      expandBoundingBoxFromCurve(
        boundingBox,
        prevCoord,
        vertex.coordinate,
        vertex.curve
      );
    } else {
      expandBoundingBoxFromCoordinate(boundingBox, vertex.coordinate);
    }
    prevCoord = vertex.coordinate;
  }
  boundingBox.width = boundingBox.right - boundingBox.left;
  boundingBox.height = boundingBox.bottom - boundingBox.top;
  return boundingBox;
};
function expandBoundingBoxFromCurve(boundingBox, startCoord, endCoord, controlPoint) {
  for (let i = 0; i < CURVE_BOUNDBOX_CHECKS; i++) {
    const t = i / (CURVE_BOUNDBOX_CHECKS - 1);
    const x = (1 - t) * (1 - t) * startCoord.x + 2 * (1 - t) * t * controlPoint.x + t * t * endCoord.x;
    const y = (1 - t) * (1 - t) * startCoord.y + 2 * (1 - t) * t * controlPoint.y + t * t * endCoord.y;
    expandBoundingBoxFromCoordinate(boundingBox, { x, y });
  }
}
function expandBoundingBoxFromCoordinate(boundingBox, coord) {
  boundingBox.top = Math.min(coord.y, boundingBox.top);
  boundingBox.bottom = Math.max(coord.y, boundingBox.bottom);
  boundingBox.left = Math.min(coord.x, boundingBox.left);
  boundingBox.right = Math.max(coord.x, boundingBox.right);
}
const extractBoundingBoxFromCircle = (shape) => {
  return {
    top: shape.position.y - shape.radius,
    left: shape.position.x - shape.radius,
    bottom: shape.position.y + shape.radius,
    right: shape.position.x + shape.radius,
    width: shape.radius * 2,
    height: shape.radius * 2
  };
};
const extractBoundingBoxFromRectangle = (shape) => {
  return {
    top: shape.position.y,
    left: shape.position.x,
    bottom: shape.position.y + shape.size.height,
    right: shape.position.x + shape.size.width,
    width: shape.size.width,
    height: shape.size.height
  };
};
const extractBoundingBoxFromShape = (shape) => {
  switch (shape.type) {
    case "polygon":
      return extractBoundingBoxFromPolygonVertices(shape.vertices);
    case "circle":
      return extractBoundingBoxFromCircle(shape);
    case "rectangle":
      return extractBoundingBoxFromRectangle(shape);
  }
};

export { extractBoundingBoxFromCircle, extractBoundingBoxFromPolygonVertices, extractBoundingBoxFromRectangle, extractBoundingBoxFromShape };
//# sourceMappingURL=extractBoundingBoxFromShape.js.map
